import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RegisterDialogMailViewComponent } from '../register-dialog-mail-view/register-dialog-mail-view.component';


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  isAnonymous: boolean;
  constructor(public dialog: MatDialog) {}
  openDialog(): void {
    const dialogRef = this.dialog.open(RegisterDialogMailViewComponent, {
      width: '250px'
    });

    dialogRef.afterClosed().subscribe(() => {

    });
  }
  ngOnInit() {

  }

}
